module.exports = __webpack_public_path__ + "media/images/logos/multistate-favicon-16x16-46bd5b116e19236f33c3bae179ec46e4.png";